<template>
  <div class="page_main">
    <div class="search_block">
      <div class="ml-3">
        <Button class="mr-3" type="success" @click="search">刷新</Button>
        <Button class="mr-3" type="primary" @click="init">初始化</Button>
        <Button class="mr-3" type="primary" @click="addModal = true">新增</Button>
      </div>
      <!-- <Button class="mr-3" type="warning" @click="deleteBatch">批量删除</Button> -->
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--新增-->
    <Modal
      v-model="addModal"
      title="新增"
      :footer-hide="true"
      
      :closable="false"
      @on-visible-change="addModelChange"
    >
      <serviceInfoadd
        @close="addModal = false"
        @loadData="search"
      ></serviceInfoadd>
    </Modal>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="编辑版本"
      :footer-hide="true"
      
      :closable="false"
    >
      <serviceInfoedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></serviceInfoedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="版本详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <serviceInfodetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></serviceInfodetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import serviceInfoadd from "../serviceInfo/add.vue";
import serviceInfoedit from "../serviceInfo/edit.vue";
import serviceInfodetail from "../serviceInfo/detail.vue";

export default {
  components: { DataTable, serviceInfoadd, serviceInfoedit, serviceInfodetail },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      selectedClientIds: [],
      selectionData: [],
      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "服务名称", key: "dicName" },
          { title: "服务Code", key: "dicCode" },
          { title: "xml配置", key: "xmlinfo", tooltip: true },
          { title: "更新包", key: "updateFilePath", tooltip: true },

          {
            title: "操作",
            width: "200px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),

                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.id);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "serviceInfo/getList",
        search: {
          // ClientSN: "",
          // ClientName: "",
          // ClientType: "",
        },
      },
    };
  },

  activated(){
    this.search()
  },

  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },
    init: function () {
      this.$api.post("/serviceInfo/init").then((rsp) => {
        if (rsp.statusCode == "200") {
          this.$Message.success(rsp.msg);
          this.search();
        } else {
          this.$Message.success("初始化失败");
        }
      });
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "操作不可逆,是否继续？",
        mask: false,
        onOk: () => {
          this.$api.post(`/serviceInfo/delete?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    addModelChange(data) {
      if (
        data &&
        document.getElementsByClassName("ivu-upload-list").length > 0
      ) {
        document.getElementsByClassName("ivu-upload-list")[0].innerHTML = "";
      }
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>